import React from 'react'
import '../Ramz.css'
import Flag from '../../../assets/Ramz/gerb.png'

const Gerb=()=>{
  return(
    <div className='Flag'>
      <img src={Flag} alt="" />
      <div className='Flag__title'>
      Davlat gerbi dumaloq koʻrinishga ega boʻlib, bu shaklning soʻl tomoni rizq-roʻzimiz timsoli — bugʻdoy boshoqlaridan, oʻng tomoni esa oʻzbekning dongʻini dunyoga taratgan bebaho boyligimiz — chanoqlari ochilgan gʻoʻza shoxlaridan iborat chambarga oʻralgan, uzoqdagi togʻlar va daryolar manzarasida gullagan vodiy uzra quyosh zarrin nurlarini sochib turadi, ayni paytda bu Oʻzbekistonning serquyosh mamlakat ekanligini ham bildiradi. Gerbning yuqori qismida esa Oʻzbekiston ozodligining ramzi sifatida sakkizburchak yulduz, uning ichki qismida yarimoy va yulduz ma`nosi mamlakat aholisining ko`p qismi islom diniga etiqod qilishi, markazida — baxt va erksevarlik ramzi — qanotlarini yozgan Xumo qushi tasvirlangan. Gerbning pastki qismida Oʻzbekiston Respublikasi davlat bayrogʻini ifoda etuvchi chambar tasmasiga „Oʻzbekiston“ deb yozib qoʻyilgan.
      </div>
    </div>
  )
}
export default Gerb